import { Box, MenuItem, TextField, Typography } from "@mui/material";

import type { SsnReadiness } from "features/adminUsers/adminUsers";
import { sourceCandidateLabel, sourceFieldHint } from "./sourceSsnChoice";

interface SourceSsnFileFieldProps {
  readiness: SsnReadiness | null;
  /** The choice shown: a major job id, or null for "no source". */
  value: number | null;
  onChange: (value: number | null) => void;
  useSsnMatch: boolean;
  hasFolder: boolean;
  disabled?: boolean;
}

/** The Download major job whose SSN file an upload job reads as its source. */
export default function SourceSsnFileField({
  readiness,
  value,
  onChange,
  useSsnMatch,
  hasFolder,
  disabled = false,
}: SourceSsnFileFieldProps) {
  const candidates = readiness?.source_candidates ?? [];
  const off = disabled || !useSsnMatch || !hasFolder || !readiness;
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
        Source SSN file
      </Typography>
      <TextField
        select
        fullWidth
        size="small"
        value={value == null ? "" : String(value)}
        onChange={(e) =>
          onChange(e.target.value === "" ? null : Number(e.target.value))
        }
        disabled={off}
        error={Boolean(readiness?.source_choice_error)}
        helperText={sourceFieldHint({ useSsnMatch, hasFolder, readiness })}
        SelectProps={{ displayEmpty: true }}
      >
        <MenuItem value="">
          <em>Not chosen - match by names</em>
        </MenuItem>
        {candidates.map((candidate) => (
          <MenuItem
            key={candidate.major_job_id}
            value={String(candidate.major_job_id)}
          >
            {sourceCandidateLabel(candidate)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
